
































































































































import Component from "vue-class-component";
import _ from "lodash";
import Http from "front-component/Http";
import StandardList from "front-component/components/List.vue";
import SocleBundleClientCode from "./light-fields/ClientCode.vue";
import SocleBundleHierarchyFullName from "./light-fields/HierarchyFullName.vue";
import SocleBundleStoreGroup from "./light-fields/StoreGroup.vue";
import SocleBundleIsValidated from "./light-fields/isValidated.vue";
import SocleBudgetStatus from "./light-fields/budgetStatus.vue";
import SocleBundleBudgetLabel from "./light-fields/BudgetLabel.vue";
import SocleBundleBudgetAmount from "./light-fields/BudgetAmount.vue";
import SocleBundleValidationDeadline from "./light-fields/ValidationDeadline.vue";
import SocleBundleCampaignCode from "./light-fields/CampaignCode.vue";
import SocleBundleCampaignLabel from "./light-fields/CampaignLabel.vue";
import SocleBundleFormattedWeek from "./light-fields/FormattedWeek.vue";
import SocleBundleBrand from "./light-fields/Brand.vue";
import EventBus from "front-component/EventBus";
import {Prop, Watch} from "vue-property-decorator";
import BundleRepository from "@/repositories/socle/BundleRepository";
import {Getter} from "vuex-class";
import {User} from "front-component/modules/User";
import {SocleClient} from "@/modules/Socle";
import {Bundle} from "@/modules/socle/Bundle";

const components = {
    SocleBundleClientCode,
    SocleBundleIsValidated,
    SocleBundleHierarchyFullName,
    SocleBundleValidationDeadline,
    SocleBundleCampaignCode,
    SocleBundleCampaignLabel,
    SocleBundleFormattedWeek,
    SocleBundleBrand,
    SocleBundleBudgetLabel,
    SocleBundleBudgetAmount,
    SocleBundleStoreGroup,
    SocleBudgetStatus,
};

@Component({ components })
export default class ListLight extends StandardList {
    public loading: boolean = false;
    public elements: object[] = [];
    public countBudgets: number = 0;
    public countBundles: number = 0;
    public globalBudget: number = 0;

    public infoBundleMassValidation: any = {};
    public dialogBudgetLightForm = false;

    @Prop() public configSocleData!: SocleClient;

    @Getter("getCurrentUser") public currentUser!: User|null;

    @Watch("filters") private cleanSelectedCampaign(): void {
        this.retrieveAllFilteredBudget();
    }

    public created(): void {
        this.retrieveAllFilteredBudget();
        window.addEventListener("scroll", this.handleScroll);
        this.fields = Http.computeStandardFields(components, "bundle");
        EventBus.$on("budget-status-updated", this.retrieveAllFilteredBudget);
        EventBus.$on("mass-budget-status-updated", this.handleMassCatalogStatusUpdated);
    }

    protected link() {
        return BundleRepository.getSearchUrl();
    }

    private handleMassCatalogStatusUpdated() {
        this.countBudgets = 0;
        this.refreshList();
        this.retrieveAllFilteredBudget();
    }

    private retrieveAllFilteredBudget() {
        const filters = this.filters;
        _.set(filters, "socleLight", true);

        const params = { filters };
        if (!filters) {
            return;
        }

        if (_.get(this, "currentUser.socleApprover", false)) {
            Http.get(
                "/socle/count-bundles-to-approve",
                params,
                (data: any) => {
                    this.infoBundleMassValidation = data;
                    this.countBundles = data.nbBundles;
                },
                "errorLoadingCountBundles"
            );
        }
        Http.get(
            "/countallsoclebudgettovalidate",
            params,
            (data: any) => {
                this.countBudgets = data[0].budgetCount;
                this.globalBudget = data[0].globalBudget;
            },
            "errorLoadingCampaigns"
        );
    }

    public launchBundleEdition(uuid: string) {
        this.$emit("show-bundle", {uuid});
    }

    public closed(): void {
        this.dialogBudgetLightForm = false;
    }

    private launchAllValidationBudgetForm(budget: boolean = false) {
        if (_.get(this, "currentUser.socleApprover", false) && !budget) {
            this.dialogBudgetLightForm = true;
        } else {
            this.$emit("show-validation-budget", [], true, this.countBudgets, this.globalBudget);
        }
    }

    private validateBudgets(): any {
        this.loading = true;
        const params = { filters: this.filters};
        Http.get(
            "/socle/mass-approve-bundles",
            params,
            () => {
                this.loading = false;
                this.dialogBudgetLightForm = false;
                this.refreshList();
                this.$message({
                    message: _.invoke(this.$options.filters, "trans", "BudgetsValidationSuccess"),
                    type: "success"
                });
            },
            "errorValidateBudgets"
        );
    }

    private handleScroll() {
        const fadeElement: any = document.querySelector(".selectedBadge");
        if (window.scrollY > 0) {
            if (fadeElement) {
                fadeElement.style.display = "none";
            }
        } else {
            if (fadeElement) {
                fadeElement.style.display = "block";
            }
        }
    }

}
